export const GITHUB_REPOS_URL =
  'https://api.github.com/users/guilhermeportella/repos?sort=pushed&per_page=100';

export const PAGE_SIZE = 9;

export const SORT_OPTIONS = [
  { value: 'recent', label: 'Mais recentes' },
  { value: 'stars-desc', label: 'Mais estrelas' },
  { value: 'stars-asc', label: 'Menos estrelas' },
  { value: 'name-asc', label: 'Nome (A-Z)' },
  { value: 'name-desc', label: 'Nome (Z-A)' },
  { value: 'created', label: 'Criados recentemente' },
];
